module.exports = __webpack_public_path__ + "static/media/eye-orange.3cf34937.svg";